import Nav from "./Nav";
import React from "react";
import styled from "styled-components";
import Footer from "./Footer";
import { Container } from "components/global/Nav";
import FAQItems from "assets/data/FAQs.json";
import Accordion from "components/global/Accordion";
import { NavLink } from "react-router-dom";

const Wrapper = styled.div`
  margin-top: 9.5rem;
  padding-top: 9.6rem;
  padding-bottom: 9.6rem;

  @media (max-width: 768px) {
    padding-top: 4.8rem;
    padding-bottom: 4.8rem;
  }

  color: var(--grey_1);
  h1 {
    line-height: 7.6rem;
    font-size: 7.2rem;
    @media (max-width: 768px) {
      font-size: 3.2rem;
      line-height: 4rem;
    }
  }
 
  .side-ctn{
    margin-left: auto;
    width: 19.6rem;;
  }
  .side-nav {
    display: flex;
    /* margin-left: auto; */
    /* margin-right: 0; */
    z-index: 40;
    flex-direction: column;
    font-size: 1.8rem;
    line-height: 2.4rem;
    text-align: right;
    color: var(--grey_5);
    position: absolute;
    /* top: 0; */
    /* top: 19.1rem; */
    /* right: 0; */
    a + a {
      margin-top: 2.4rem;
    }
    .active {
      color: var(--primary);
    }
    @media (max-width: 768px) {
      display: none;
    }
  }
  .limit {
    max-width: 60.3rem;
    font-size: 2rem;
    line-height: 2.6rem;
    margin: 2.4rem 0 9.6rem;
    @media (max-width: 768px) {
      margin: 1.2rem 0 4.8rem;
    }
  }
  .container{
    position: relative;
  }
`;
const FAQs = () => {
  return (
    <>
      <Nav />
      <Wrapper className="outer-most-container">
        <Container className="container">
          <div className="flexRow">
            <div>
              <h1>
                Frequently Asked
                <br /> Questions
              </h1>
              <p className="limit">
                We've compiled answers to some common questions, and we hope
                this helps you understand our app.
              </p>
            </div>
            <div className="side-ctn">
              <div className="side-nav">
                <NavLink activeClassName="active" to="/legal/terms">
                  Terms of Service
                </NavLink>
                <NavLink activeClassName="active" to="/legal/privacy-policy">
                  Privacy Policy
                </NavLink>
                <NavLink activeClassName="active" to="/faqs">
                  Frequently asked questions
                </NavLink>
              </div>
            </div>
          </div>
          {FAQItems.map((ele) => (
            <Accordion
              withBorder={true}
              answer={ele.answer}
              question={ele.question}
            />
          ))}
        </Container>
      </Wrapper>
      <Footer />
    </>
  );
};

export default FAQs;
